import { h, render, nextTick } from 'vue'

// https://github.com/pearofducks/mount-vue-component
// https://stackoverflow.com/a/69491554
// https://wmartins.github.io/2019/05/a-deep-dive-into-children-in-vue/

// Usage

// import ModalWindow
// import ComponentContent
// modalWindowProps = { wrapperClass: 'max-w-2xl overflow-y-auto rounded-xl bg-white p-4 shadow-lg' }
// componentContent = { heading: 'hello world' }
// createComponent(ModalWindow, modalWindowProps, ComponentContent, componentContent)

function createComponent2 (wrapperComponent, wrapperProps = {}, componentContent = {}, componentProps = {}) {
  let el = document.createElement('div')
  document.body.appendChild(el)

  let vNode = null

  async function destroy () {
    await render(null, el)
    await nextTick()
    vNode = null
    el.remove()
    el = null
  }

  componentProps = { ...componentProps, onDestroy: destroy }
  componentContent = h(componentContent, componentProps)

  wrapperProps = { ...wrapperProps, onDestroy: destroy }
  vNode = h(wrapperComponent, wrapperProps, () => componentContent)

  render(vNode, el)

  return { vNode, destroy }
}

export default createComponent2